import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Login from '../containers/Login';
import LoginCallback from '../containers/LoginCallback';
import ProtectedRoute from '../containers/ProtectedRoute';
import Composer from '../containers/Composer';
import PostList from '../containers/PostList';
import ComposerMediaPreview from '../containers/ComposerMediaPreview';

export interface AppPropsFromState {
    loading: boolean
    loggedInUser: User
    errorMessage: string
}

interface User {
    name: string
    url: string
    photo: string
}

class App extends Component<AppPropsFromState, any> {

    constructor(props: AppPropsFromState) {
        super(props)
    }

    render() {
        const { errorMessage, loading, loggedInUser } = this.props

        let headerClass = "w-100 pa1 bw2 bl"
        if (loading) {
            headerClass = headerClass + " b--blue"
        }
        if (errorMessage) {
            headerClass = headerClass + " b--red"
        }

        return (
            <div>
                <header
                    className={headerClass}
                >

                    {loggedInUser && loggedInUser.url ? (
                        <span>
                            <img
                                className="ma1 v-mid"
                                src={loggedInUser.photo}
                            />
                            <a
                                className="v-mid"
                                href={loggedInUser.url}
                            >
                                {loggedInUser.name}
                            </a>
                        </span>
                    ) : (
                         <span>
                         You are not logged in
                         </span>
                    )
                    }

                    {errorMessage &&
                     <span>{errorMessage}</span>
                    }

                </header>

                <main className="mw6 center">
                    <ProtectedRoute exact path='/' component={Composer} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/login-callback" component={LoginCallback} />
                    <Route exact path="/composer/media/gallery" component={PostList} />
                    <Route path="/composer/media/preview/:photoID" component={ComposerMediaPreview} />
                </main>

            </div>
        );
    }
}

export default App;
